var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "@mui/material/styles";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { cardActionStylesFn, cardStylesFn } from "./Card.styles";
import { COLORS } from "../../../constants";
/**
 * NOTES for elevation/outline:
 * Cards have 2 variants, elevated and outlined
 * cards cannot have an elevation if theyre outlined
 * dragged state of outlined needs to be elevated per design
 * instead of using outline variant on card, need to instead make our own
 * if not outline variant is supplied card is by default elevated to 1
 * default elevation to 0
 */
var Card = function (_a) {
    var variant = _a.variant, children = _a.children, disabled = _a.disabled, dragged = _a.dragged, selected = _a.selected, clickHandler = _a.clickHandler, selectable = _a.selectable, _b = _a.hasHoverBg, hasHoverBg = _b === void 0 ? true : _b, cardState = _a.cardState, squareOnMobile = _a.squareOnMobile, _c = _a.elevation, elevation = _c === void 0 ? 0 : _c, _d = _a.value, value = _d === void 0 ? "" : _d, sx = _a.sx, rest = __rest(_a, ["variant", "children", "disabled", "dragged", "selected", "clickHandler", "selectable", "hasHoverBg", "cardState", "squareOnMobile", "elevation", "value", "sx"]);
    var theme = useTheme();
    /**
     * border color changes based on state of card
     */
    var borderColor = (function () {
        switch (cardState) {
            case "active":
                return theme.palette.primary.main;
            case "pending":
                return COLORS.P_DISABLED;
            default:
                return COLORS.P_MED_EMPHASIS;
        }
    })();
    /**
     * if card is selected return an icon indicating that
     * TBD: should probably allow for any icon, and make circle default
     */
    var getIcon = function () {
        if (selected) {
            return (_jsx("div", __assign({ style: {
                    textAlign: "end",
                    marginRight: "12px",
                    marginTop: "12px",
                } }, { children: _jsx(CheckCircleIcon, { style: { color: theme.palette.primary.main } }) })));
        }
        return null;
    };
    /**
     * click handler for selectable card, return optional passed in value
     */
    var handleClick = function () {
        if (clickHandler) {
            clickHandler(value);
        }
    };
    var consolidatedCardStyles = __assign(__assign({}, cardStylesFn({
        borderColor: borderColor,
        hasHoverBg: hasHoverBg,
        variant: variant,
        elevation: elevation,
        disabled: disabled,
        selected: selected,
        dragged: dragged,
        breakpoints: theme.breakpoints,
        squareOnMobile: squareOnMobile,
    })), sx);
    /**
     * returns card with out without action area based on if card is selectable
     */
    var getInnerCard = function () {
        if (selectable) {
            return (_jsxs(CardActionArea, __assign({ "data-testid": "card-inner-selectable", sx: cardActionStylesFn({ disabled: disabled }), disabled: disabled, onClick: handleClick }, { children: [getIcon(), children] })));
        }
        return (_jsxs(React.Fragment, { children: [getIcon(), children] }));
    };
    return (_jsx(MuiCard, __assign({}, rest, { elevation: elevation, sx: consolidatedCardStyles }, { children: getInnerCard() })));
};
export default Card;
